import { createUseStyles } from '@glu/theming';

import { BREAKPOINT700 } from 'constants.js';

const styles = ({ breakpoints, images, spacing }) => ({
  container: {
    background: `url('${images.login.marketing}') center no-repeat`,
    backgroundSize: '100% 100%',
    display: 'flex',
    flexDirection: 'column',
    minHeight: 425,
    minWidth: 335,
    padding: spacing.unit * 3,
    [`@media only screen and (max-width: ${BREAKPOINT700}px)`]: {
      display: 'none'
    }
  },
  marketingContent: {
    alignItems: 'center',
    display: 'flex',
    height: '100%',
    justifyContent: 'center',
    width: '100%',
    [`@media only screen and (max-width: ${breakpoints.values.sm}px)`]: {
      display: 'none'
    }
  }
});

export default createUseStyles(styles);
